// The discard prompt is the only copy `Dialog` renders on its own behalf, so it
// carries its own translations rather than making all 90 dialogs pass them in.
export const T = {
  en_GB: {
    discardTitle: "Discard changes?",
    discardDescription: "This dialog has unsaved changes. Closing it now will discard them.",
    close: "Close",
    discard: "Discard",
    keepEditing: "Keep editing",
  },
  nb_NO: {
    discardTitle: "Forkaste endringer?",
    discardDescription: "Dialogen har ulagrede endringer. Lukker du den nå, blir de forkastet.",
    close: "Lukk",
    discard: "Forkast",
    keepEditing: "Fortsett redigering",
  },
} as const;
